import gsap from "gsap/dist/gsap";
import ScrollTrigger from "gsap/dist/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.arrive(".contatti", {existing: true}, function (){

  gsap.to(".section-title-contatti-text", {
    duration: 1,
    scrollTrigger: {
      trigger: ".section-title-contatti-text",
      toggleClass: "animate",
      toggleActions: "restart none restart none"
    }
  })

  gsap.to(".richiedi-text", {
    x: 30,
    opacity: 1,
    duration: 1,
    scrollTrigger: {
      trigger: ".richiedi-text",
      toggleActions: "restart none resume none"
    }
  })
  gsap.to(".mail", {
    x: 30,
    opacity: 1,
    duration: 1,
    scrollTrigger: {
      trigger: ".mail",
      toggleActions: "restart none resume none"
    }
  })
  gsap.to(".more-info", {
    duration: 1,
    scrollTrigger: {
      trigger: ".more-info",
      toggleClass: "no-opacity",
      toggleActions: "none none resume none"
    }
  })

})